// extracted by mini-css-extract-plugin
module.exports = {"divider":"_2vD0w_wPTK_calculator","horizontal":"_2Bp76SzdKM_calculator","line":"_3lDjqan6cZ_calculator","dashed":"dYxcTVjc-Z_calculator","vertical":"_19pcb5NqHl_calculator"};